import { createGetElementData } from "data/form/elementSelectors";
import { Actions, PatchConfig } from "data/form/types";
import { Middleware } from "redux";
import { JSON_PATCH } from "../data/form/actionTypes";

// HACK: Until the API handles safely handles patching to an index
// of an array that might not exist

const formPatchMiddleware: Middleware = store => next => (action: Actions) => {
	if (action.type === JSON_PATCH) {
		const additionalPatches: PatchConfig[] = [];

		for (let index = 0; index < action.patch.length; index++) {
			const patch = action.patch[index];

			if (patch.op !== "add" && patch.op !== "replace") continue;

			const regex = /^(\/.+)(\/[0-9]+|\/-)$/;

			// Figure out if it's an array based on the path
			if (regex.test(patch.path)) {
				// Check if the parent array exists in the data already
				const matches = patch.path.match(regex);

				if (!matches) continue;
				const parentId = matches[1];

				// If there is another patch in the patches array with the ID of the parent
				// assume that this issue is handled
				if (action.patch.find(p => p.path === parentId)) continue;

				// else try to get the parent data
				const getData = createGetElementData();
				const parentData = getData(store.getState(), {
					fid: action.fid,
					id: parentId,
					rowIndex: patch.rowIndex,
					uuid: patch.uuid,
					vid: patch.vid,
				});

				// If the parent doesn't exist add a patch op to create it
				if (!parentData || parentData.value === undefined) {
					additionalPatches.push({
						op: "add",
						path: parentId,
						id: parentId,
						data: { value: [] },
						vid: patch.vid,
						rowIndex: patch.rowIndex,
						uuid: patch.uuid,
					});
				}
			}
		}

		// Patch order is important so we prepend the additions
		action.patch = [...additionalPatches, ...action.patch];
	}

	next(action);
};

export default formPatchMiddleware;
